module.exports = __webpack_public_path__ + "static/media/ezugi.a25c6d07.svg";